export default __webpack_public_path__ + "static/media/plain-sticker-k.cb6d4073.png";